export const selectCreditAmount = (state) => state?.userData?.creditDTO?.amount || 0;
export const selectUserCardNumber = (state) => state?.userData?.cardNumber;
export const selectUserUsername = (state) => state?.userData?.username;
